// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-block-container {
    padding: 5px;
}

.slider-block-container p {
    padding: 5px
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLSliderBlock/ECLSliderBlock.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ","sourcesContent":[".slider-block-container {\r\n    padding: 5px;\r\n}\r\n\r\n.slider-block-container p {\r\n    padding: 5px\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
